import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-moving-step5-done',
  templateUrl: './moving-step5-done.component.html',
  styleUrls: ['./moving-step5-done.component.scss']
})
export class MovingStep5DoneComponent implements OnInit {

    public thisID: number = 0;
    private sub: any;
    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.thisID = +params['syid'];
        });
    }

}
